export default "__VITE_ASSET__DBx_yHoN__"